import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';
import { Dispatch } from 'redux';

import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import { tabValueAndCauseFieldChange, setCurrentTabAsDirty } from '../../../../store/details/svs/actions';
import { ValueAndCauseDTO as ValueAndCauseType } from '../../../../business/models/dto/svs/svs.dto';
import styles from './svs.module.css';
import BelfiusCurrencyText from '../../../custom/belfius-currency-text';
import { BelfiusCurrencyInput } from '../../../custom/belfius-currency-input';
import Checkbox from '@mui/material/Checkbox';
import { Role } from '../../../../store/shared/model';

interface PropsFromDispatch {
  readonly tabValueAndCauseFieldChange: typeof tabValueAndCauseFieldChange;
  readonly setCurrentTabAsDirty: typeof setCurrentTabAsDirty;
}

interface PropsFromState {
  readonly data: {
    valueBuildingBeforeAccident: string;
    valueContentBeforeAccident: string;
    damageCauseRemark: string;
    cloneInsuredAmountBuilding: string;
    cloneInsuredAmountContent: string;
  };

  readonly insuredAmountBuilding: number | '';
  readonly insuredAmountContent: number | '';
  readonly damageCauseRemarkIsValid: boolean;
  readonly locked: boolean;
  readonly cloned: boolean;
  readonly svsHeaderId: number;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class ValueAndCause extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  private get insuredAmounts() {
    if (this.props.cloned) {
      return (
        <div className={styles.row}>
          <div className={`${styles.item} ${styles.border}`}>
            <span className={styles.text}>
              {this.localization.get('details.shared.insuredAmountBuilding')}
            </span>
          </div>
          <div className={`${styles.item} ${styles.border}`}>
            <BelfiusCurrencyInput className={styles.input}
              disabled={this.props.locked}
              value={this.props.data.cloneInsuredAmountBuilding}
              placeholder={this.localization.get('details.rim.valueAndCause.value')}
              onChange={() => {
                this.props.setCurrentTabAsDirty();
              }}
              onValueChange={(values: { value: string }) => {
                this.props.tabValueAndCauseFieldChange({
                  damageCauseRemark: this.props.data.damageCauseRemark,
                  valueContentBeforeAccident: this.props.data.valueContentBeforeAccident === '' ? '' : +this.props.data.valueContentBeforeAccident,
                  valueBuildingBeforeAccident: this.props.data.valueBuildingBeforeAccident === '' ? '' : +this.props.data.valueBuildingBeforeAccident,
                  cloneInsuredAmountBuilding: values.value === '' ? '' : +values.value,
                  cloneInsuredAmountContent: this.props.data.cloneInsuredAmountContent === '' ? '' : +this.props.data.cloneInsuredAmountContent,
                  cloned: this.props.cloned
                });
              }}
            />
          </div>
          <div className={`${styles.item} ${styles.border}`}>
            <span className={styles.text}>
              {this.localization.get('details.shared.insuredAmountContent')}
            </span>
          </div>
          <div className={`${styles.item} ${styles.border}`}>
            <BelfiusCurrencyInput className={styles.input}
              disabled={this.props.locked}
              value={this.props.data.cloneInsuredAmountContent}
              placeholder={this.localization.get('details.rim.valueAndCause.value')}
              onChange={() => {
                this.props.setCurrentTabAsDirty();
              }}
              onValueChange={(values: { value: string }) => {
                this.props.tabValueAndCauseFieldChange({
                  damageCauseRemark: this.props.data.damageCauseRemark,
                  valueContentBeforeAccident: this.props.data.valueContentBeforeAccident === '' ? '' : +this.props.data.valueContentBeforeAccident,
                  valueBuildingBeforeAccident: this.props.data.valueBuildingBeforeAccident === '' ? '' : +this.props.data.valueBuildingBeforeAccident,
                  cloneInsuredAmountBuilding: this.props.data.cloneInsuredAmountBuilding === '' ? '' : +this.props.data.cloneInsuredAmountBuilding,
                  cloneInsuredAmountContent: values.value === '' ? '' : +values.value,
                  cloned: this.props.cloned
                });
              }}
            />
          </div>
        </div>
      );
    }
    return (
      <div className={styles.row}>
        <div className={`${styles.item} ${styles.border}`}>
          <span className={styles.text}>
            {this.localization.get('details.shared.insuredAmountBuilding')}:&nbsp;
             <BelfiusCurrencyText value={this.props.insuredAmountBuilding} prefix={'€ '} />
          </span>
        </div>
        <div className={`${styles.item} ${styles.border}`}>
          <span className={styles.text}>
            {this.localization.get('details.shared.insuredAmountContent')}:&nbsp;
             <BelfiusCurrencyText value={this.props.insuredAmountContent} prefix={'€ '} />
          </span>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <div className={styles.content}>
          {!this.props.svsHeaderId ?
            <div className={styles.row}>
              <div className={`${styles.item} ${styles.border}`}>
                <div className={styles.checkbox}>
                  <Checkbox
                    checked={this.props.cloned}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                      if (!event.target.checked) {
                        this.props.tabValueAndCauseFieldChange({
                          valueBuildingBeforeAccident: this.props.data.valueBuildingBeforeAccident.trim() === '' ? '' : +this.props.data.valueBuildingBeforeAccident,
                          valueContentBeforeAccident: this.props.data.valueContentBeforeAccident.trim() === '' ? '' : +this.props.data.valueContentBeforeAccident,
                          damageCauseRemark: this.props.data.damageCauseRemark,
                          cloneInsuredAmountBuilding: '',
                          cloneInsuredAmountContent: '',
                          cloned: event.target.checked
                        });
                      } else {
                        this.props.tabValueAndCauseFieldChange({
                          valueBuildingBeforeAccident: this.props.data.valueBuildingBeforeAccident.trim() === '' ? '' : +this.props.data.valueBuildingBeforeAccident,
                          valueContentBeforeAccident: this.props.data.valueContentBeforeAccident.trim() === '' ? '' : +this.props.data.valueContentBeforeAccident,
                          damageCauseRemark: this.props.data.damageCauseRemark,
                          cloneInsuredAmountBuilding: this.props.data.cloneInsuredAmountBuilding === '' ? '' : +this.props.data.cloneInsuredAmountBuilding,
                          cloneInsuredAmountContent: this.props.data.cloneInsuredAmountContent === '' ? '' : +this.props.data.cloneInsuredAmountContent,
                          cloned: event.target.checked
                        });
                      }
                      this.props.setCurrentTabAsDirty();
                    }}
                    value='true' />
                  {this.localization.get('details.svs.clone')}
                </div>
              </div>
            </div> : ''}
        </div>
        <div className={styles.content}>
          {this.insuredAmounts}
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.svs.valueAndCause.valueBuildingBeforeAccident')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <BelfiusCurrencyInput className={styles.input}
                disabled={this.props.locked}
                value={this.props.data.valueBuildingBeforeAccident}
                placeholder={this.localization.get('details.rim.valueAndCause.value')}
                onChange={() => {
                  this.props.setCurrentTabAsDirty();
                }}
                onValueChange={(values: { value: string }) => {
                  this.props.tabValueAndCauseFieldChange({
                    damageCauseRemark: this.props.data.damageCauseRemark,
                    valueContentBeforeAccident: this.props.data.valueContentBeforeAccident === '' ? '' : +this.props.data.valueContentBeforeAccident,
                    valueBuildingBeforeAccident: values.value === '' ? '' : +values.value,
                    cloneInsuredAmountBuilding: this.props.data.cloneInsuredAmountBuilding === '' ? '' : +this.props.data.cloneInsuredAmountBuilding,
                    cloneInsuredAmountContent: this.props.data.cloneInsuredAmountContent === '' ? '' : +this.props.data.cloneInsuredAmountContent,
                    cloned: this.props.cloned
                  });
                }}
              />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <span className={styles.text}>
                {this.localization.get('details.svs.valueAndCause.valueContentBeforeAccident')}
              </span>
            </div>
            <div className={`${styles.item} ${styles.border}`}>
              <BelfiusCurrencyInput className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.svs.valueAndCause.value')}
                value={this.props.data.valueContentBeforeAccident}
                onChange={(value: string) => {
                  this.props.setCurrentTabAsDirty();
                }}
                onValueChange={(values: { value: string }) => {
                  this.props.tabValueAndCauseFieldChange({
                    damageCauseRemark: this.props.data.damageCauseRemark,
                    valueBuildingBeforeAccident: this.props.data.valueBuildingBeforeAccident === '' ? '' : +this.props.data.valueBuildingBeforeAccident,
                    valueContentBeforeAccident: values.value === '' ? '' : +values.value,
                    cloneInsuredAmountBuilding: this.props.data.cloneInsuredAmountBuilding === '' ? '' : +this.props.data.cloneInsuredAmountBuilding,
                    cloneInsuredAmountContent: this.props.data.cloneInsuredAmountContent === '' ? '' : +this.props.data.cloneInsuredAmountContent,
                    cloned: this.props.cloned
                  });
                }}
              />
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              {!this.props.damageCauseRemarkIsValid &&
                <div className={styles.columnForRowValidation}>
                  <div className={styles.svsRowNotValid} ></div>
                </div>
              }
              <div className={styles.columnMaxWidth}>
                <textarea className={styles.text}
                  disabled={this.props.locked}
                  maxLength={500}
                  placeholder={this.localization.get('details.svs.valueAndCause.damageCauseRemark')}
                  value={this.props.data.damageCauseRemark}
                  rows={3}
                  onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                    this.props.setCurrentTabAsDirty();
                    this.props.tabValueAndCauseFieldChange({
                      valueBuildingBeforeAccident: this.props.data.valueBuildingBeforeAccident.trim() === '' ? '' : +this.props.data.valueBuildingBeforeAccident,
                      valueContentBeforeAccident: this.props.data.valueContentBeforeAccident.trim() === '' ? '' : +this.props.data.valueContentBeforeAccident,
                      damageCauseRemark: event.target.value,
                      cloneInsuredAmountBuilding: this.props.data.cloneInsuredAmountBuilding === '' ? '' : +this.props.data.cloneInsuredAmountBuilding,
                      cloneInsuredAmountContent: this.props.data.cloneInsuredAmountContent === '' ? '' : +this.props.data.cloneInsuredAmountContent,
                      cloned: this.props.cloned
                    });
                  }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsSvs, detailsPolicy }, caseState: { selectedCase }, shared: { roles } }: ApplicationState): PropsFromState => ({
  data: {
    valueBuildingBeforeAccident: detailsSvs.valueAndCause.valueBuildingBeforeAccident === '' || detailsSvs.valueAndCause.valueBuildingBeforeAccident === undefined || detailsSvs.valueAndCause.valueBuildingBeforeAccident === null ? '' : detailsSvs.valueAndCause.valueBuildingBeforeAccident.toString(),
    valueContentBeforeAccident: detailsSvs.valueAndCause.valueContentBeforeAccident === '' || detailsSvs.valueAndCause.valueContentBeforeAccident === undefined || detailsSvs.valueAndCause.valueContentBeforeAccident === null ? '' : detailsSvs.valueAndCause.valueContentBeforeAccident.toString(),
    damageCauseRemark: detailsSvs.valueAndCause.damageCauseRemark,
    cloneInsuredAmountBuilding: detailsSvs.valueAndCause.cloneInsuredAmountBuilding === '' || detailsSvs.valueAndCause.cloneInsuredAmountBuilding === undefined || detailsSvs.valueAndCause.cloneInsuredAmountBuilding === null ? '' : detailsSvs.valueAndCause.cloneInsuredAmountBuilding.toString(),
    cloneInsuredAmountContent: detailsSvs.valueAndCause.cloneInsuredAmountContent === '' || detailsSvs.valueAndCause.cloneInsuredAmountContent === undefined || detailsSvs.valueAndCause.cloneInsuredAmountContent === null ? '' : detailsSvs.valueAndCause.cloneInsuredAmountContent.toString()
  },
  insuredAmountBuilding: detailsPolicy.policy.insuredAmountBuilding,
  insuredAmountContent: detailsPolicy.policy.insuredAmountContent,
  damageCauseRemarkIsValid: detailsSvs.damageCauseRemarkIsValid,
  locked: detailsSvs.locked || selectedCase.blocked || !roles.includes(Role.ExFiLoAd),
  cloned: detailsSvs.valueAndCause.cloned,
  svsHeaderId: detailsSvs.id
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  tabValueAndCauseFieldChange: (data: ValueAndCauseType) => dispatch(tabValueAndCauseFieldChange(data)),
  setCurrentTabAsDirty: () => dispatch(setCurrentTabAsDirty())
});

export default connect(mapStateToProps, mapDispatchToProps)(ValueAndCause);
